<template>
  <div v-if="!hideBtns" class="footer-btns-next">
    <v-btn color="primary" class="btn-prev"
           x-large depressed
           :disabled="dtlDisabledPrev"
           v-if="!isDisabledBtn"
           @click="$emit('before')">이전
    </v-btn>
    <v-btn color="primary" class="btn-next"
           x-large depressed
           :disabled="dtlDisabledNext"
           @click="$emit('next')">다음
    </v-btn>
  </div>
</template>
<script>
export default {
  props: ['current', 'total', 'disabledNext', "unitDtlUseList"],
  computed: {
    hideBtns() {
      return this.dtlDisabledPrev && this.dtlDisabledNext
    },
    popupYn() {
      return this.$route.query.popupYn === 'true' || this.$route.query.popupYn
    },
    // eslint-disable-next-line vue/return-in-computed-property
    cmpltYn() {
      if (this.$route.query.cmpltYn === 'false')
        return false
      return this.$route.query.cmpltYn === 'true' || this.$route.query.cmpltYn
    },
    isDisabledBtn() {
      return this.cmpltYn && this.current === 1
    },
    dtlDisabledPrev() {
      if (this.popupYn) { // 가이드 피드백 & 광장 등 팝업으로 뜨는 경우 intro, finish 무시
        return this.current === 1
      } else {
        return this.current === 0
      }
    },
    dtlDisabledNext() {
      if (this.popupYn) { // 가이드 피드백 & 광장 완료 페이지 노출로 변경됨 (intro는 안보임) => solutionContainer.vue 참고
        // return this.current === this.total + 1 || this.disabledNext
        return false
      } else {
        return this.current === this.total || this.disabledNext
      }
    }
  },
  created() {
  }
}
</script>
